/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-02 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { site } from 'src/config/';

import * as syncActions from 'actions/sync-actions';

type Props = {
  name: string
};

function componentWithSyncWrapper(WrappedComponent: Object, processName) {
  class HOCComponentWithSyncWrapper extends Component<Props> {
    timeoutProcessingSync = undefined;
    state = {
      // Condition for processing update banner
      showScheduleSync: false,
      syncDuration: 0
    };

    componentDidMount() {
      const { getSyncProcessStatus } = this.props;

      // Get sync process status
      getSyncProcessStatus();
    }

    componentWillReceiveProps(nextProps) {
      const { syncProcessLoading } = nextProps;
      const { syncProcessLoading: syncProcessLoadingPrev } = this.props;

      // Update banner from process sync
      if (syncProcessLoadingPrev && !syncProcessLoading) {
        const { flow, scheduleSyncInfo, getSyncProcessStatus } = nextProps;
        const { status, remainingTime } = flow;

        if (status === 'done') {
          // Has schedule sync
          const { scheduleAt, estimatedDuration } = scheduleSyncInfo;

          if (scheduleAt) {
            let syncDuration = scheduleAt - Math.floor(Date.now() / 1000);
            syncDuration = syncDuration > 0 ? syncDuration : 0;
            syncDuration = Math.floor((syncDuration + estimatedDuration) / 60);
            this.setState({ syncDuration, showScheduleSync: true });

            // Call sync process status
            clearTimeout(this.timeoutProcessingSync);
            // Set timeout call sync status
            this.timeoutProcessingSync = setTimeout(() => {
              getSyncProcessStatus();
            }, site.syncStatusTimeout);
          } else {
            const { showScheduleSync } = this.state;
            if (showScheduleSync) {
              // Banner is showed, update message done in 30s
              this.setState({ syncDuration: -1, showScheduleSync: true });

              setTimeout(() => {
                this.setState({ syncDuration: 0, showScheduleSync: false });
                getSyncProcessStatus();
              }, 30000);
            } else {
              // Status done, no schedule sync, close banner
              this.setState({ syncDuration: 0, showScheduleSync: false });
            }
          }
        } else {
          // Status = "running" ||"error" || anything else
          if (remainingTime) {
            let syncDuration = Math.floor(remainingTime / 60);
            this.setState({ syncDuration, showScheduleSync: true });
          }

          // Call sync process status
          clearTimeout(this.timeoutProcessingSync);
          // Set timeout call sync status
          this.timeoutProcessingSync = setTimeout(() => {
            getSyncProcessStatus();
          }, site.syncStatusTimeout);
        }
      }
    }

    componentWillUnmount() {
      const { resetSyncStatus } = this.props;

      resetSyncStatus();
      clearTimeout(this.timeoutProcessingSync);
    }

    render() {
      const { showScheduleSync, syncDuration } = this.state;
      const { getSyncProcessStatus } = this.props;
      return (
        <WrappedComponent
          {...this.props}
          showScheduleSync={showScheduleSync}
          syncDuration={syncDuration}
          getSyncProcessStatus={getSyncProcessStatus}
          updateShowBanner={this.updateShowBanner}
        />
      );
    }

    updateShowBanner = (syncDuration, showScheduleSync) => {
      this.setState({ syncDuration, showScheduleSync: true });
    };
  }

  const mapStateToProps = (state, props) => ({
    syncProcessLoading: _.get(state.sync, 'syncProcessLoading', false),
    flow: _.get(state.sync, 'flow', {}),
    scheduleSyncInfo: _.get(state.sync, 'scheduleSyncInfo', {})
  });

  const mapDispatchToProps = (dispatch, props) => ({
    // Sync process status
    getSyncProcessStatus: () => dispatch(syncActions.getSyncProcessStatus(processName)),
    resetSyncStatus: () => dispatch(syncActions.resetSyncStatus())
  });

  return connect(mapStateToProps, mapDispatchToProps)(HOCComponentWithSyncWrapper);
}

export default componentWithSyncWrapper;
